const {h, render, Component} = require('preact');

class Search extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    var searchText = document.getElementsByClassName("search-input-text")[0];
    searchText.value = '';
  }

  render() {
    return (
        <div class="search_container" data-bhw="web2018_search_bar">
          <div class="search">
            <div class="icon-magnifying-glass search-icon" for="search" onClick={this.props.getTextAndSearch} data-bhw="web2018_search_icon"></div>
            <div class="search-box" onClick={this.props.focusOnSearchInput}>
              {(this.props.searchText) ?
                <input type="search" name="search" class="search-input-text" maxlength="100"
                value={this.props.searchText} autocomplete="off"
                aria-label="search-topics" label="search-topics" onKeyPress={this.props.handleChangeInSearchInput} /> :
                <input type="search" name="search" class="search-input-text" maxlength="100"
                placeholder={I18n.translate("js.modules.web_2018.search_placeholder_text")} autocomplete="off"
                aria-label="search-topics" label="search-topics" onKeyPress={this.props.handleChangeInSearchInput} />
              }

            </div>
          </div>
        </div>
    );
  }
}

module.exports = Search
